import { render, staticRenderFns } from "./EateryCard.vue?vue&type=template&id=10423392&scoped=true&"
import script from "./EateryCard.vue?vue&type=script&lang=js&"
export * from "./EateryCard.vue?vue&type=script&lang=js&"
import style0 from "./EateryCard.vue?vue&type=style&index=0&id=10423392&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10423392",
  null
  
)

export default component.exports